module.exports = __webpack_public_path__ + "3766d38b0216289f3b708d0d287c2481.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Naomi.png
// module id = 1154
// module chunks = 0